/**
 * @file: aiEditionTabs.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 *
 * The AI edition's tabs: the AI home, the three areas it is sold for, then
 * the messages every store has (the workshop app's tab, as it is).
 * The bottom bar (phone) and the sidebar (iPad, web) both list these.
 */

import {
  MessageIcon,
  MessageIconFill,
} from '@euler/app/components/sidebar/icons/MessageIcon';
import { StoreFeature } from '@euler/model/enum';
import {
  ChartColumn,
  LucideIcon,
  MessagesSquare,
  Sparkles,
  Users,
} from 'lucide-react-native';

export type AiEditionTabName =
  | 'AiHome'
  | 'AiMarketing'
  | 'AiDashboards'
  | 'AiCoaching'
  | 'Inbox';

export interface AiEditionTab {
  name: AiEditionTabName;
  label: string;
  renderIcon: (size: number, color: string, active: boolean) => JSX.Element;
  /** Null for a tab every store has. */
  feature: StoreFeature | null;
  /** Badge it with the inbox's unread count. */
  showUnread: boolean;
}

const lucide =
  (Icon: LucideIcon): AiEditionTab['renderIcon'] =>
  (size, color) => <Icon size={size} color={color} />;

export const kAiEditionTabs: readonly AiEditionTab[] = [
  {
    name: 'AiHome',
    label: '知车AI',
    renderIcon: lucide(Sparkles),
    feature: StoreFeature.AiAssistant,
    showUnread: false,
  },
  {
    name: 'AiMarketing',
    label: '私域营销',
    renderIcon: lucide(Users),
    feature: StoreFeature.Apdm,
    showUnread: false,
  },
  {
    name: 'AiDashboards',
    label: '数据看板',
    renderIcon: lucide(ChartColumn),
    feature: StoreFeature.Bi,
    showUnread: false,
  },
  {
    name: 'AiCoaching',
    label: '销售对练',
    renderIcon: lucide(MessagesSquare),
    feature: StoreFeature.Coaching,
    showUnread: false,
  },
  {
    name: 'Inbox',
    label: '消息中心',
    renderIcon: (size, color, active) =>
      active ? (
        <MessageIconFill size={size} fill={color} />
      ) : (
        <MessageIcon size={size} fill={color} />
      ),
    feature: null,
    showUnread: true,
  },
];
